import { RawText } from 'components/Text'

export const Text = ({ value }: { value: string }) => <RawText lineHeight={1}>{value}</RawText>
